import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { ContentCarouselCardStoryblok } from '../../../../types/storyblok';
import { Type } from '../../../../base/Type/Type';
import Markup from '../../../../base/Markup/Markup';
import Link from '../../../../base/Link/Link';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';

export const ContentCarouselCardDesktop = ({
  heading,
  description,
  link,
  image,
}: ContentCarouselCardStoryblok) => (
  <Box
    as="article"
    className="md:flex gap-10 flex-row md:gap-15 lg:gap-20 px-5 hidden"
    overlayOverBkg
  >
    <Box as="div" className="w-full md:w-2/5">
      <Type as="h2" className="mb-5 text-h2">
        {heading}
      </Type>
      <Markup content={description} className="text-p1" />
      <Link href={link} variant="secondary" className="mt-5">
        Read more
      </Link>
    </Box>
    <Box as="div" className="w-full md:w-3/5">
      <StoryblokImage
        src={image}
        mode="responsive"
        maxWidth={1000}
        alt={heading}
        className="rounded"
      />
    </Box>
  </Box>
);
